import React from "react";
import { createPDFimagenH002 } from "../../Service/Service.laboratorioPDF";

export default function ResumenCitas({ citas, onConsultar, onLlamar }) {
  return (
    <div>
      <h5 className="card-title mb-3">Listado de Citas</h5>
      <small className="text-muted">Últimas 5 citas</small>

      <table className="table table-sm" style={{ fontSize: "13px" }}>
        <thead>
          <tr>
            <td>Fecha</td>
            <td>Hora</td>
            <td>Doctor</td>
            <td>Estado</td>
            <td>Opción</td>
          </tr>
        </thead>
        <tbody>
          {citas?.map((cita, index) => (
            <tr key={index}>
              <td>{cita.fecha_inicio}</td>
              <td>{cita.hora_inicio}</td>
              <td>{cita.doctor?.nombre || "Sin doctor"}</td>
              <td>
                <span
                  className={`badge px-3 py-2 mt-1 fw-bold fs-6 rounded-pill shadow-sm ${
                    cita.estado_cita.estado === "Finalizada"
                      ? "bg-success"
                      : cita.estado_cita.estado === "En Consulta"
                      ? "bg-warning"
                      : cita.estado_cita.estado === "Cancelada"
                      ? "bg-danger"
                      : "bg-secondary"
                  }`}
                >
                  {cita.estado_cita.estado}
                </span>
              </td>
              <td>
                <span
                  className="btn btn-sm btn-soft-primary rounded-pill shadow-sm"
                  onClick={() => onConsultar(cita.idcita)}
                >
                  Ver <i className="fas fa-eye mx-1"></i>
                </span>

                <span
                  className="btn btn-sm btn-soft-success ms-2 rounded-pill shadow-sm"
                  onClick={() => onLlamar(cita)}
                >
                  Llamar <i className="fas fa-ticket-alt mx-1"></i>
                </span>
                <span
                  className="btn btn-sm btn-soft-primary rounded-pill shadow-sm"
                  onClick={() => createPDFimagenH002(cita.idcita)}
                >
                  H002 <i className="fas fa-eye mx-1"></i>
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
